import DanceWeb from "../assets/images/webps/dance-specialevent-service.webp";
import Dance from "../assets/images/others/dance-specialevent-service.jpg";
import SpecialEntriesWeb from "../assets/images/webps/Specialentries-specialevent-services.webp";
import SpecialEntries from "../assets/images/others/Specialentries-specialevent-services.jpg";
import PhotographerWeb from "../assets/images/webps/Photographers-specialevent-services.webp";
import Photographer from "../assets/images/others/Photographers-specialevent-services.jpg";
import MakeupWeb from "../assets/images/webps/Make-upArtists-specialevent-services.webp";
import Makeup from "../assets/images/others/Make-upArtists-specialevent-services.jpg";

export const SpecialServiceData = [
  {
    id: "ss101",
    name: "Dance Choreography",
    description:
      "We provide dancers around the Mumbai. access to a diverse selection of quality choreography that can be performed on any stage.",
    imgWeb: DanceWeb,
    imgNorm: Dance,
  },
  {
    id: "ss102",
    name: "Special Entries",
    description:
      "We offer unique wedding entry for bride and groom, designed and styled in a way to ensure that you enjoy the most important occasion of your life in the best possible way.",
    imgWeb: SpecialEntriesWeb,
    imgNorm: SpecialEntries,
  },
  {
    id: "ss103",
    name: "Phototgraphers",
    description:
      "We provide photographers that strive to capture those beautiful moments and milestones for you to treasure and share with your loved ones. ",
    imgWeb: PhotographerWeb,
    imgNorm: Photographer,
  },
  {
    id: "ss104",
    name: "Makeup Artist",
    description:
      "We provide highly dedicated and skilled Makeup Artist with an exceptional record of customer service and client satisfaction. Adept at perceiving individual client's unique skin tone and corresponding makeup needs and recommending products accordingly.",
    imgWeb: MakeupWeb,
    imgNorm: Makeup,
  },
];
